/* FP Black Friday 2026: aftellen, cadeau kiezen. */
(function () {
  'use strict';
  var st = document.createElement('style');
  st.textContent = '.fpbf-shelf{max-width:560px;margin-left:auto}.fpbf-shelf .fpbf-card:nth-child(n+5){display:none}.fpbf-card{padding:10px}.fpbf-card img{aspect-ratio:1/1;max-height:230px;object-fit:contain;background:#fff}@media(max-width:899px){.fpbf-shelf{max-width:none}.fpbf-card img{max-height:170px}}';
  document.head.appendChild(st);
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    document.querySelectorAll('[data-fpbf-end]').forEach(function (box) {
      var end = Date.parse(box.getAttribute('data-fpbf-end'));
      var d = Math.max(0, end - Date.now());
      var s = Math.floor(d / 1000);
      var vals = { d: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60), s: s % 60 };
      Object.keys(vals).forEach(function (k) {
        var el = box.querySelector('[data-fpbf-' + k + ']');
        if (el) el.textContent = pad(vals[k]);
      });
    });
  }
  tick();
  setInterval(tick, 1000);

  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-fpbf-add]') : null;
    if (!b || b.disabled) return;
    b.disabled = true; b.textContent = '...';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: Number(b.getAttribute('data-fpbf-add')), quantity: 1 }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () {
        try { sessionStorage.setItem('fpbf_reopen', '1'); } catch (x) {}
        window.location.reload();
      })
      .catch(function () { b.disabled = false; b.textContent = 'Kies'; });
  });

  try {
    if (sessionStorage.getItem('fpbf_reopen') === '1') {
      sessionStorage.removeItem('fpbf_reopen');
      if (document.body.className.indexOf('template-cart') === -1) {
        window.addEventListener('load', function () {
          setTimeout(function () { var c = document.querySelector('.header__icon--cart'); if (c) c.click(); }, 700);
        });
      }
    }
  } catch (x) {}
})();